var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProjectIncludes, Project } from '@/models/Project';
import Chat from '@/components/chat/Chat';
import AddSubjectDialog from '@/components/AddSubjectDialog/AddSubjectDialog';
import ErrorHandler from '@/support/ErrorHandler';
import DataTable from '@/components/data-table/DataTable';
let Subjects = class Subjects extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isAddingSubjects = false;
        this.selected = [];
        this.tableKey = 0;
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    // #endregion
    // #region Class methods
    async updateSubjects(projectSubjects) {
        const subjects = projectSubjects
            .map((projectSubject) => projectSubject.id);
        const response = await new Project(this.project)
            .include([
            ProjectIncludes.AUDIT,
            ProjectIncludes.CHAT,
            ProjectIncludes.USERS,
            ProjectIncludes.SUBJECTS,
            ProjectIncludes.ROLES,
            ProjectIncludes.PARENT,
            ProjectIncludes.NOTES,
            ProjectIncludes.LEVEL,
        ])
            .update({ subjects })
            .catch((error) => ErrorHandler.network(error));
        if (!response) {
            return;
        }
        this.updateProject(response);
    }
    updateProject(project) {
        const mergedProjects = {
            ...this.project,
            ...project,
        };
        const newProject = new Project(mergedProjects);
        this.$emit('update:project', newProject);
    }
    dialogOptions() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.deleteMultiple', 0, { item: this.$t('dialogOptions.item.subjects'), amount: this.selected.length }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!this.project || !this.selected.length) {
                            return;
                        }
                        const payload = this.selected.map((subject) => subject.id);
                        this.project
                            .detachSubjectsFromProject(this.project.id, payload)
                            .then((response) => {
                            if (response) {
                                this.project.subjects = this.projectSubjects.filter((subject) => !payload.includes(subject.id));
                                this.selected = [];
                                this.tableKey += 1;
                            }
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                },
            },
        };
    }
    openDialog() {
        this.$store.dispatch('openDialog', this.dialogOptions());
    }
    // #endregion
    // #region Async methods
    async deleteSelectedSubject(subject) {
        const subjects = this.projectSubjects
            .filter((projectSubject) => projectSubject.id !== subject.id)
            .map((projectSubject) => projectSubject.id);
        const response = await new Project(this.project)
            .include([
            ProjectIncludes.AUDIT,
            ProjectIncludes.CHAT,
            ProjectIncludes.USERS,
            ProjectIncludes.SUBJECTS,
            ProjectIncludes.ROLES,
            ProjectIncludes.PARENT,
            ProjectIncludes.NOTES,
            ProjectIncludes.LEVEL,
        ])
            .update({ subjects })
            .catch((error) => ErrorHandler.network(error));
        if (!response) {
            return;
        }
        this.updateProject(response);
    }
    // #endregion
    // #region Getters & Setters
    get projectSubjects() {
        return this.project && this.project.subjects || [];
    }
    get tableHeaders() {
        return [
            { text: 'Hoofdgebied', value: 'parent.parent' },
            { text: 'Deelgebied', value: 'parent' },
            { text: 'Leerdoel', value: 'name', width: '40%' },
            { text: 'Niveau', value: 'level', width: '10%' },
            { text: '', value: 'actions', width: '50px', align: 'right' },
        ];
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof Project !== "undefined" && Project) === "function" ? _a : Object)
], Subjects.prototype, "project", void 0);
Subjects = __decorate([
    Component({
        components: {
            Chat,
            AddSubjectDialog,
            DataTable,
        },
    })
], Subjects);
export default Subjects;
